import type { WorkOrderStatus } from "@myapp/contract";

/**
 * The eleven statuses, in the order the menu lists them — grouped by where the Auftrag stands, so a
 * manager hunting for "Nachfolge geplant 2" does not scan a flat list of near-identical labels.
 */
export const STATUS_GROUPS: ReadonlyArray<{
  label: string;
  statuses: ReadonlyArray<WorkOrderStatus>;
}> = [
  { label: "Planung", statuses: ["NOT_PLANNED", "PLANNED", "NOT_REACHED"] },
  {
    label: "Nachfolge",
    statuses: [
      "FOLLOW_UP_REQUIRED_1",
      "FOLLOW_UP_PLANNED_1",
      "FOLLOW_UP_REQUIRED_2",
      "FOLLOW_UP_PLANNED_2",
    ],
  },
  {
    label: "Erledigt",
    statuses: ["COMPLETED", "COMPLETED_FOLLOW_UP_1", "COMPLETED_FOLLOW_UP_2"],
  },
  // Closed without the work being done: „Gelöscht" is not a form of „Erledigt".
  { label: "Beendet", statuses: ["CANCELLED"] },
];
